import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { LocalizationService } from '../../services/localization.service';
@Component({
    selector: 'app-not-found-dialog',
    templateUrl: './not-found-dialog.html',
})
export class NotFoundDialogComponent {

    public mainForm: FormGroup;
    public captchaUrl: string;

    constructor(
        public dialogRef: MatDialogRef<NotFoundDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        public loc: LocalizationService)
    {
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/not-found-dialog/not-found-dialog.ts